import { useAppSelector } from "../../../hooks";
import { selectUser } from "../../../states/slices/authReducer";
import { useLocation, useNavigate } from "react-router-dom";

import {
  LISPENDES_LOGO_ANAMBRA,
  NOTIFICATIONS,
  PROFILE,
} from "../../../assets";
import clsx from "clsx";
import { FaBars } from "react-icons/fa";

function Header({
  setSideNavVisible,
}: {
  setSideNavVisible: (value: boolean) => void;
}) {
  const user = useAppSelector(selectUser);
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <>
      <div
        className={clsx(
          "lg:flex  items-center hidden px-5 py-2  w-full border border-b",
          user?.judicial_division ? "justify-between" : "justify-end"
        )}
      >
        {user?.judicial_division && (
          <div className=" flex items-center gap-x-4">
            <div className="w-fit px-5 py-2 rounded-lg bg-[#155DFC0D] text-[#155DFC] font-medium text-sm">
              <span>{`Judicial Division:${user?.judicial_division}`}</span>
            </div>
            <div className="w-fit px-4 py-2 rounded-lg text-sm bg-lightGold text-globalGold">
              <span>Court {user?.court_number}</span>
            </div>
          </div>
        )}

        <div className="lg:flex hidden items-center justify-end gap-x-3">
          {location.pathname.includes("/court-staff") && (
            <button
              type="button"
              onClick={() => navigate("/court-staff/notifications")}
              className="lg:flex hidden relative"
            >
              <img
                src={NOTIFICATIONS}
                className="w-[40px] h-[40px] hover:scale-95 transition-all duration-200"
                alt=""
              />
              {/* {unreadNotifications?.length > 0 && (
            <div className="w-[20px] absolute h-[20px] -right-1 -top-2 text-white text-[10px] rounded-full bg-red-600 flex items-center justify-center">
              {unreadNotifications?.length}
            </div>
          )} */}
            </button>
          )}

          <div className="lg:flex hidden items-center gap-x-2 border-l pl-2">
            <img
              src={PROFILE}
              className="w-[40px] h-[40px] rounded-full object-cover"
              alt=""
            />
            <div className="flex items-end">
              <div className="flex flex-col items-start">
                <span className="text-sm font-semibold">
                  {user?.name?.replace(/_/g, " ") || "User"}
                </span>
                <span className="text-xs font-normal text-[#72777A]">
                  {user?.type?.replace(/_/g, " ") || "User Type"}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="flex items-center justify-between lg:hidden p-5">
        <img
          src={LISPENDES_LOGO_ANAMBRA}
          className="w-[200px] h-[49px]"
          alt=""
        />
        <button
          onClick={() => setSideNavVisible(true)}
          className="flex items-center justify-center w-[30px] h-[30px] hover:bg-gray-200 rounded-full"
        >
          <FaBars />
        </button>
      </div>
    </>
  );
}

export default Header;
